import React from "react";

const StockCardTooltip = ({ 
  name, 
  sector, 
  sectorEmoji, 
  dividend, 
  isOwned, 
  isCarryover 
}) => {
  let additionalInfo = '';
  if (dividend > 0) {
    additionalInfo += `🪙 Dividend: $${dividend} every 2 rounds`;
  }
  if (isOwned) {
    additionalInfo += additionalInfo ? `\n✅ You own this stock` : `✅ You own this stock`;
  }
  if (isCarryover) {
    additionalInfo += additionalInfo ? `\n⭐ Carryover from previous round` : `⭐ Carryover from previous round`;
  }
  
  return (
    <div className="stock-tooltip-content">
      <div className="stock-tooltip-title">
        {name}{sector ? ` (${sector})` : ''}
      </div>
      {additionalInfo && (
        <div className="stock-tooltip-info">
          {additionalInfo.split('\n').map((line, idx) => (
            <div key={idx}>{line}</div>
          ))}
        </div>
      )}
    </div>
  );
};

// Price breakdown tooltip component (used for pricing section)
export const PriceBreakdownTooltip = ({ 
  baseCost, 
  indexPrice, 
  sectorEmoji, 
  sector, 
  growthCost, 
  growth, 
  stocksOwned, 
  manipulatorEffect, 
  manipulatorCards, 
  marketPrice,
  previousPrice 
}) => {
  let priceBreakdown = `Price Calculation:\n`;
  priceBreakdown += `📈 Price = 💲 Base Cost + ${sectorEmoji} + 📈 ± 🎴\n`;
  
  // Show previous price if available
  if (previousPrice !== null && previousPrice !== undefined) {
    const priceChange = marketPrice - previousPrice;
    const changeSign = priceChange >= 0 ? '+' : '';
    priceBreakdown += `Previous: $${previousPrice} (${changeSign}$${priceChange})\n`;
  }
  
  priceBreakdown += `Base Cost: $${baseCost}\n`;
  priceBreakdown += `Index Price: $${indexPrice}${sectorEmoji ? ` (${sectorEmoji} ${sector})` : ''}\n`;
  priceBreakdown += `Growth: $${growthCost} (${growth} × ${stocksOwned} owned)\n`;
  
  if (manipulatorEffect !== 0) {
    const manipulatorSign = manipulatorEffect >= 0 ? '+' : '';
    const manipulatorDetails = manipulatorCards.map(card => {
      const sign = card.effectValue >= 0 ? '+' : '';
      return `${card.displayValue || card.name}: ${sign}${card.effectValue}`;
    }).join(', ');
    priceBreakdown += `Manipulators: ${manipulatorSign}${Math.abs(manipulatorEffect)} (${manipulatorDetails})\n`;
  } else {
    priceBreakdown += `Manipulators: $0\n`;
  }
  
  priceBreakdown += `━━━━━━━━━━━━━\n`;
  priceBreakdown += `Total: $${marketPrice}`;
  
  const renderLine = (line) => {
    // Check if line is a separator
    if (line.startsWith('━━')) {
      return <div key={line}>{line}</div>;
    }
    
    // Check if line contains a label (text before colon)
    const colonIndex = line.indexOf(':');
    if (colonIndex > 0) {
      const label = line.substring(0, colonIndex + 1);
      const value = line.substring(colonIndex + 1);
      return (
        <div key={line}>
          <span className="stock-tooltip-line">{label}</span>
          {value}
        </div>
      );
    }
    
    // For lines without colons (like the formula line), return as-is
    return <div key={line}>{line}</div>;
  };
  
  return (
    <div className="stock-tooltip-content">
      {priceBreakdown.split('\n').map((line, idx) => (
        <React.Fragment key={idx}>{renderLine(line)}</React.Fragment>
      ))}
    </div>
  );
};

export default StockCardTooltip;

